import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { IMAGE_FILETYPE } from "../app.constants";
import { UtilsService } from "./_utils.service";

@Injectable({
  providedIn: "root"
})
export class VideoUtilsService {
  constructor(private utils: UtilsService) {}

  captureVideoThumbnailFromUrl(videoUrl: string, thumbName: string): Observable<File> {
    return new Observable<File>((observer) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.muted = true;
      video.onloadedmetadata = () => {
        video.currentTime = 0;
      };
      video.onseeked = () => {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth || 320;
        canvas.height = video.videoHeight || 240;
        canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(
          (blob) => {
            video.src = "";
            if (blob) {
              observer.next(new File([blob], thumbName, { type: "image/jpeg" }));
              observer.complete();
            } else {
              observer.error(new Error("Failed to capture video thumbnail frame"));
            }
          },
          "image/jpeg",
          0.8
        );
      };
      video.onerror = () => {
        observer.error(new Error("Failed to load video for thumbnail capture"));
      };
      video.src = videoUrl;
    });
  }

  captureVideoThumbnail(file: File): Observable<File> {
    const objectUrl = URL.createObjectURL(file);
    const thumbFileName = this.utils.changeExtension(file.name, IMAGE_FILETYPE.EXTENSION_JPEG);
    return this.captureVideoThumbnailFromUrl(objectUrl, thumbFileName).pipe(finalize(() => URL.revokeObjectURL(objectUrl)));
  }

  getLocalVideoDuration(fileUrl: string): Observable<number | null> {
    return new Observable<number | null>((observer) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = () => {
        const dur = isFinite(video.duration) ? video.duration : null;
        observer.next(dur);
        observer.complete();
        video.src = "";
      };
      video.onerror = () => {
        observer.next(null);
        observer.complete();
      };
      video.src = fileUrl;
    });
  }
}
